module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10037.b506cde6.jpg";